import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { SubheaderWrapper } from '../../../styled';
import { FormikTextInput } from 'components/forms/formik-prime';
import { NewStyledButton } from 'components/prime/NewButton/styled';
import { PrimeTextButton } from 'components/prime/TextButton/TextButton';
import { addRollbarIntegration } from 'fetchers/actions/addRollbarIntegration';
import { Form, Formik } from 'formik';
import { Box, Flex } from 'rebass';
import { HorizontalLine } from 'screens/User/components/GeneralInfoFields';
import { displaySnackbar } from 'store/slices/snackbarSlice';

import { InputWrapper } from './styled';
import { validationSchema } from './validationSchema';

interface Props {
  onClose: () => void;
  canIntegrate: boolean;
  isIntegrated: boolean;
}

interface RollbarIntegrationForm {
  token: string;
  organization_name: string;
}

export const RollbarSection = ({
  onClose,
  canIntegrate,
  isIntegrated,
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = (values: RollbarIntegrationForm) => {
    addRollbarIntegration(values)
      .then(() => {
        dispatch(
          displaySnackbar({
            message: t('organizationSettings.integrationSuccess'),
          }),
        );
        onClose();
      })
      .catch(() => {
        dispatch(
          displaySnackbar({
            message: t('organizationSettings.integrationFail'),
            isError: true,
          }),
        );
      });
  };

  return (
    <Flex flexDirection="column" mt={4}>
      {canIntegrate ? (
        <SubheaderWrapper active={true}>
          <Box mr={2} display="inline">
            <i className="pi pi-info-circle" />
          </Box>
          <Box display="inline">
            {t(
              isIntegrated
                ? 'organizationSettings.rollbar.integrationOn'
                : 'organizationSettings.rollbar.integrationValid',
            )}
          </Box>
        </SubheaderWrapper>
      ) : (
        <Formik
          initialValues={{
            token: '',
            organization_name: '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <Form>
            <InputWrapper>
              <FormikTextInput
                name="token"
                label={t('organizationSettings.rollbar.token')}
                ishigh="false"
                variant="default"
              />
              <FormikTextInput
                name="organization_name"
                label={t('organizationSettings.rollbar.organizationName')}
                ishigh="false"
                variant="default"
              />
            </InputWrapper>
            <HorizontalLine />
            <Flex justifyContent="flex-end">
              <Box mr={3}>
                <PrimeTextButton onClick={onClose} label={t('common.cancel')} />
              </Box>
              <NewStyledButton
                type="submit"
                variant="default"
                label={t('organizationSettings.rollbar.connect')}
              />
            </Flex>
          </Form>
        </Formik>
      )}
    </Flex>
  );
};
